var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 16px;\n  background: #f9f9f9;\n  height: 100%;\n  overflow-y: auto;\n"], ["\n  padding: 16px;\n  background: #f9f9f9;\n  height: 100%;\n  overflow-y: auto;\n"])));
var templateObject_1;
